import { throttle } from "../tools/utils";

const TOP_RATIO = 0.15;
const BOTTOM_RATIO = 0.1;
const MIN_SCROLL_DOWN_PX = 32;
const MIN_SCROLLABLE_RANGE_PX = 48;

export const ScrollToTop = (() => {
	const updateVisibility = (scrollToBtn) => {
		const scrollHeight = document.documentElement.scrollHeight;
		const scrollY = window.scrollY;
		const innerHeight = window.innerHeight;
		const maxScroll = Math.max(0, scrollHeight - innerHeight);

		if (maxScroll < MIN_SCROLLABLE_RANGE_PX) {
			scrollToBtn.classList.remove("is-visible");
			scrollToBtn.setAttribute("aria-hidden", "true");
			return;
		}

		const hasScrolledDown = scrollY >= MIN_SCROLL_DOWN_PX;
		const scrolledPastTopZone = scrollY > scrollHeight * TOP_RATIO;
		const inBottomZone = scrollY + innerHeight >= scrollHeight * (1 - BOTTOM_RATIO);
		const show = hasScrolledDown && scrolledPastTopZone && !inBottomZone;

		scrollToBtn.classList.toggle("is-visible", show);
		scrollToBtn.setAttribute("aria-hidden", show ? "false" : "true");
	};

	const init = (selector = ".js-scroll-top") => {
		const scrollToBtn = document.querySelector(selector);
		if (!scrollToBtn) return;

		scrollToBtn.addEventListener("click", () => {
			window.scrollTo({ top: 0, behavior: "smooth" });
		});

		const onScrollOrResize = () => updateVisibility(scrollToBtn);

		window.addEventListener("scroll", throttle(onScrollOrResize, 100), { passive: true });
		window.addEventListener("resize", throttle(onScrollOrResize, 150));

		onScrollOrResize();
	};

	return { init };
})();
